import React, { useEffect, useState } from "react";
import { Download, Loader2, Upload } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";

export default function ProtocolModelsPanel() {
  const [opts, setOpts] = useState(null);
  const [busy, setBusy] = useState(null);
  const load = () => api.get("/litiges/options").then((r) => setOpts(r.data));
  useEffect(() => { load(); }, []);
  const upload = async (pid, file) => {
    if (!file) return;
    setBusy(pid);
    const fd = new FormData();
    fd.append("file", file);
    try { await api.post(`/litiges/protocol-models/${pid}`, fd); toast.success("Modèle Word déposé"); load(); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } finally { setBusy(null); }
  };
  const download = async (p) => {
    const r = await api.get(`/litiges/protocol-models/${p.id}/file`, { responseType: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(r.data); a.download = p.model.filename; a.click();
  };
  if (!opts) return <Loader2 className="w-5 h-5 animate-spin" />;
  return (
    <div className="card-flat p-5 max-w-3xl space-y-3" data-testid="protocol-models-panel">
      <h3 className="font-heading text-base font-medium">Modèles Word des protocoles d'accord</h3>
      <p className="text-xs text-norea-textMuted">Déposez le modèle Word de chaque protocole. En attendant leur intégration, un modèle provisoire (marqué comme tel dans le PDF) est envoyé en signature.</p>
      {opts.protocols.map((p) => (
        <div key={p.id} className="flex items-center justify-between gap-3 border-t border-norea-border pt-3" data-testid={`protocol-model-${p.id}`}>
          <div><div className="text-sm font-medium">{p.label}</div>
            <div className="text-[11px] text-norea-textMuted">{p.model ? `Déposé : ${p.model.filename} (${new Date(p.model.uploaded_at).toLocaleDateString("fr-FR")})` : "Aucun modèle Word déposé — modèle provisoire utilisé"}</div></div>
          <div className="flex gap-2">
            {p.model && <button onClick={() => download(p)} className="btn-secondary text-xs inline-flex items-center gap-1" data-testid={`protocol-model-download-${p.id}`}><Download className="w-3.5 h-3.5" />Télécharger</button>}
            <label className="btn-secondary text-xs inline-flex items-center gap-1 cursor-pointer" data-testid={`protocol-model-upload-${p.id}`}>
              {busy === p.id ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}Déposer (.docx)
              <input type="file" accept=".docx,.doc" className="hidden" onChange={(e) => upload(p.id, e.target.files?.[0])} /></label>
          </div>
        </div>
      ))}
    </div>
  );
}
